/* One import point for the landing page's vocabulary.

   Everything real lives in shared/folio/kit, which the app chrome reads from
   too. This re-exports it so the leaves below have a single short import, and
   adds the one value that is local to this surface. */

export * from "../../shared/folio/kit";

export const EASE_OUT = "cubic-bezier(0.16, 1, 0.3, 1)";
